//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from "~/api/api";
import foretell from "~/mixins/foretell.js";
import { titleCase } from "~/src/titlecase";
import Plan from "@/models/Plan";
import aos from "~/mixins/aos.js";

var parseHeadlineText = function(headlineText) {
  if (!headlineText) return null;
  return titleCase(headlineText.replace(/-/g, " ").replace(/_/g, "-")).replace(
    /Llc/g,
    "LLC"
  );
};

export default {
  data() {
    return {
      show: false,
      customText: "",
    };
  },
  mixins: [foretell, aos],

  async created() {
    if (process.client) {
      if (this.$route.query.hl) {
        // remove the custom headline.
        this.customText = parseHeadlineText(this.$route.query.hl);
        let params = this.$route.params;
        this.$router.replace({
          params,
          name: this.$route.name,
        });
      }
    }
    Plan.fetchAll().then((_) => {
      this.plansLoaded = true;
    });
  },

  head() {
    if (this.pageInfo) {
      let domain = "https://www.legalnature.com";
      let canonicalLink = domain + "/plus";
      let meta = [
        { name: "description", content: this.metaInfo.description },
        { name: "keyword", content: this.metaInfo.keyword },
        { name: "og:image", content: this.metaInfo["og-image"] },
        { name: "og:title", content: this.metaInfo.title },
        { name: "og:description", content: this.metaInfo.description },
        { name: "og:type", content: "website" },
        { name: "og:url", content: canonicalLink },
      ];
      return {
        title: this.metaInfo.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {};
    }
  },
  async asyncData({ app, query, params, redirect }) {
    let pageInfo = undefined;

    try {
      pageInfo = await API.butterPages.get(app.$axios, "plus", {
        preview: query.preview ? 1 : 0,
      });
    } catch (e) {
      console.error(e);
      return {
        pageInfo: {},
        loading: false,
        error: true,
      };
    }
    return {
      pageInfo,
      loading: false,
      error: true,
    };
  },
  methods: {
    showPopover() {
      this.show = !this.show;
    },
    ctaAction() {
      this.$router.push(this.CTAlink);
    },
  },
  computed: {
    CTAlink() {
      if (this.plans) return "/checkout/annual";
      else return "";
    },
    plans() {
      return this.$store
        .$db()
        .model("plans")
        .query()
        .first();
    },
    hero() {
      if (this.pageInfo.fields.hero.table)
        return this.pageInfo.fields.hero.table;
    },
    heroFeatures() {
      if (this.pageInfo.fields.hero_features.table)
        return this.pageInfo.fields.hero_features.table;
    },
    pageBody() {
      if (this.pageInfo.fields.picker) return this.pageInfo.fields.picker;
    },
    getStarted() {
      if (this.pageInfo.fields.get_started.table) {
        let getStarted = {
          headline: this.pageInfo.fields.get_started.table.headline,
          text: this.pageInfo.fields.get_started.table.text,
        };
        return getStarted;
      }
    },
    metaInfo() {
      return this.pageInfo.fields.meta_information.table;
    },
  },
  mounted() {
    if (process.client) {
      this.createOrLoadUserWithForetellEvent("lnd", { bp: "plus" });
    }
  },
};
